/**
 * Un día de calendario dentro de un rango, comparando texto.
 *
 * `fechaEntrevista` llega como `YYYY-MM-DD`, y en ese formato el orden
 * alfabético es el cronológico. Comparar así evita pasar por `new Date()`,
 * que interpreta el día como medianoche UTC y lo corre al anterior al leerlo
 * en hora local — la misma trampa que cuida `formatDate`.
 *
 * Los dos extremos entran: quien filtra del 1 al 5 espera ver el 5.
 */
export const dentroDelRango = (
  fecha: string | null | undefined,
  desde: string,
  hasta: string,
): boolean => {
  // Sin rango capturado no se filtra nada, ni siquiera las que no traen fecha.
  if (!desde && !hasta) return true
  if (!fecha) return false

  // Por si algún día llega con hora: el rango se decide por el día.
  const dia = fecha.slice(0, 10)

  if (desde && dia < desde) return false
  if (hasta && dia > hasta) return false
  return true
}

/**
 * Si la entrevista del solicitante todavía espera su decisión.
 *
 * No basta con que la entrevista diga «pendiente»: el candidato pudo haber
 * seguido su camino por otra vía —lo mandaron a Dirección, lo descartaron, ya
 * se cerró— y entonces el trámite quedó colgado. Ofrecer ahí aprobar o
 * rechazar es ofrecer algo que el servidor rechaza con «El candidato ya no
 * está esperando la decisión del solicitante».
 *
 * `pre_seleccionado` es el valor con el que viaja «entrevista del
 * solicitante»: es el mismo estado con dos nombres, por cómo quedó el enum.
 */
export const esperaDecisionDelSolicitante = (entrevista: {
  decision?: string | null
  candidate?: { status?: string | null } | null
}): boolean =>
  entrevista.decision === 'pendiente' &&
  entrevista.candidate?.status === 'pre_seleccionado'
